export const ANALYTICS_ENDPOINT = process.env.REACT_APP_ANALYTICS_EVENTS || "https://api.huberway.com/api/v1/analytics/events";
export const HEARTBEAT_ENDPOINT = process.env.REACT_APP_ANALYTICS_HEARTBEAT || "https://api.huberway.com/api/v1/analytics/heartbeat";
export const TRACKING_VERSION = "1.0.0";

export const DEFAULT_TOTEM_ID = process.env.REACT_APP_TOTEM_ID || "TOTEM-LOCAL";
export const DEFAULT_STORE_ID = process.env.REACT_APP_STORE_ID || 1;

export const HMAC_SECRET = process.env.REACT_APP_TOTEM_HMAC_SECRET || "44453c854805328bb02fe0cfc35f3823c5403f549579f71bb1a1db1585ac86f3\n";
